import axios from "axios";
import { Messages } from "./custom/Messages";
import { isAuthenticated, getToken, updateToken, updateToken2} from "../security/AppSecurity";
import { recordError } from "../utils/logService";

const mainApiURL = process.env.NODE_ENV === "development"
  ? process.env.REACT_APP_BACKEND_API
  : window._CONFIGS.REACT_APP_BACKEND_API;

const secondApiURL = `${mainApiURL}2`;

axios.defaults.baseURL = mainApiURL;
const axiosClient = axios.create();

function setBaseUrl(config) {
  // some logic to determine base URL here
  if (config.AlterBaseURL != null && config.AlterBaseURL != undefined) {
    config.baseURL = secondApiURL;
  }else{
    config.baseURL = mainApiURL;
  }
}

// axiosClient.interceptors.response.use((output) => {
//   const expectedError = output && output.status >=400 && output.status < 500;

//   if (expectedError) {
//     // console.log(Messages.USER_REQUEST_FAILURE);
//     return Promise.reject(output);
//   } 
//   else if (output.status >= 500) {
//     const msg = Messages.SERVER_REQUEST_FAILURE;
//     // console.log("STATUS", output.status);
//     return Promise.reject(output);
//   }

//   return output;
// });

//Request interceptor for API calls
axiosClient.interceptors.request.use((config) => {
  if (isAuthenticated()) {
    config.headers.Authorization = `Bearer ${getToken()}`;
    
    updateToken(config);
  }

  //! Unauthenticated requests only for temporary occasions (ext orgs)
  setBaseUrl(config);

  return config;
});

export default {
  get: axiosClient.get,
  post: axiosClient.post,
  put: axiosClient.put,
  delete: axiosClient.delete,
  head: axiosClient.head,
  patch: axiosClient.patch,
};


